export enum DebugErrorAngular {
  ApiReachable = 'API Reachable',
  ApiUnreachable = 'API Unreachable',
}
